import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';
import { AlgoliaUser } from '@context/shared/types/search';
import { getInitials } from '@context/shared/types/user';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIconPipe } from '@taiga-ui/core';
import { TuiAvatar, TuiAvatarOutline } from '@taiga-ui/kit';

@Component({
	imports: [TuiAvatar, TuiAvatarOutline, TuiIconPipe, TranslocoModule],
	selector: 'ctx-algolia-avatar',
	templateUrl: 'algolia-avatar.component.html',
	styleUrl: 'algolia-avatar.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlgoliaAvatarComponent {
	readonly user = input<AlgoliaUser | null>(null);

	readonly initials = computed(() => {
		const user = this.user();
		if (!user) return '';

		return getInitials(user.name) ?? '';
	});

	readonly src = computed(() => {
		const user = this.user();
		if (!user) return null;

		if (user.thumbnail) return user.thumbnail;

		return this.initials();
	});
}
